import {Component} from '@angular/core';
import {Platform, Events} from 'ionic-angular';
import {ViewChild} from '@angular/core';
import {StatusBar} from 'ionic-native';
import {Api} from "../providers/api";
import {ApiOffline} from "../providers/api-offline";
import {ToastController, AlertController, MenuController, LoadingController, ModalController} from 'ionic-angular';
import {Headers, RequestOptions} from '@angular/http';

// import pages
import {HomePage} from '../pages/home/home';
import {LoginPage} from '../pages/login/login';
import {WelcomePage} from '../pages/welcome/welcome';
import {MyAccountPage} from '../pages/my-account/my-account';
import {CartPage} from '../pages/cart/cart';
import {SettingsPage} from '../pages/settings/settings';
import {MyOrderPage} from '../pages/my-order/my-order';
import {ListCustomersPage} from '../pages/list-customers/list-customers';
import {ItemsPage} from '../pages/items/items';
import {CART, loginUserInfo, ROLE, STOCKCART} from '../providers/data';
import {CartManager} from '../providers/cart-manager';
import {CustomerCarts} from '../providers/user-cart-provider/user-carts';
import {InternetCheckPopupPage} from '../pages/internet-check-popup/internet-check-popup';
import {Storage} from '@ionic/storage';
import {DatabaseProvider} from '../providers/database/database';
import ImgCache from 'imgcache.js';
import {ImageLoaderConfig} from 'ionic-image-loader';
import {Constants, ApplicationVariables, IMAGES_BASE_URL} from '../providers/config';
import {Network} from '@ionic-native/network';
import { StockcartPage } from '../pages/stockcart/stockcart';
import {MoveStockCartPage} from "../pages/move-stock-cart/move-stock-cart";
import {GVLogger} from "../services/gv-logger";
import {BadInventoryPage} from "../pages/bad-inventory/bad-inventory";
import {ApproveReturnPage} from "../pages/approve-return/approve-return";
import {ReceiveReturnPage} from "../pages/receive-return/receive-return";
import {WarehousesPage} from "../pages/warehouses/warehouses";
import {WorkOrdersPage} from "../pages/work-orders/work-orders";
import {BulkShipmentPage} from "../pages/bulk-shipment/bulk-shipment";
import {ConsumeStockCart} from "../pages/consume-stock-cart/consume-stock-cart";
import {MsgManager} from "../providers/msg-manager";


// end import pages

@Component({
  templateUrl: 'app.html',
  queries: {
    nav: new ViewChild('content')
  },
  providers: [CustomerCarts, CartManager]
})
export class MyApp {

  public rootPage: any;
  public cart: any;
  public nav: any;

  public pages = [];
  public backupPages = [];
  public networkAlert: any;
  public loadControll: any;
  adpCustomerInfo:any = {};
  stockCart: any;
  restrictedToViewOrder = loginUserInfo.restrictedToViewOrder;

  constructor(public platform: Platform,
              public customerCarts: CustomerCarts,
              public cartManager: CartManager,
              public api: Api,
              public apiOffline: ApiOffline,
              public toastCtrl: ToastController,
              imageLoaderConfig: ImageLoaderConfig,
              public menuController: MenuController,
              public alertCtrl: AlertController,
              public events: Events,
              public storage: Storage,
              public dbService: DatabaseProvider,
              private network: Network,
              private loadingCtrl: LoadingController,
              private modalCtrl: ModalController,
              private gVLogger: GVLogger,
              private msgManager: MsgManager) {

    localStorage.removeItem("isLoggedIn");

    this.rootPage = WelcomePage;
    this.cart = CART;
    this.stockCart = STOCKCART;

    if (Constants.isWebstore) { // WEBSTORE MERGE
      window.onbeforeunload = function (e) {
        if (cartManager.getItems().length > 0) {

          var dialogText = 'There are products in cart.';
          e.returnValue = dialogText;
          return dialogText;
        }
      };
    }


    this.network.onDisconnect().subscribe(() => {

      ApplicationVariables.connectionType = this.network.type;

      if (localStorage.getItem("isLoggedIn") &&
        localStorage.getItem("isLoggedIn") == 'true' &&
        !ApplicationVariables.isOffline &&
        !Constants.isWebstore && Constants.IntelliStockRunningIn === "NA") {

        this.networkAlert = this.modalCtrl.create(InternetCheckPopupPage, null, {enableBackdropDismiss: false});
        this.networkAlert.present();
      }


    });


    this.network.onConnect().subscribe(() => {

      setTimeout(() => {
        ApplicationVariables.connectionType = this.network.type;
        this.apiOffline.isInternetConnected().then((res) => {

          if (localStorage.getItem("isLoggedIn") && localStorage.getItem("isLoggedIn") == 'true') {
            this.networkAlert.dismiss();
          }
          let t = this.toastCtrl.create({
            message: "Service Connected, you can switch back to online mode",
            duration: 3000,
            position: 'bottom'
          });
          t.present();

        }, rej => {

          let t = this.toastCtrl.create({
            message: "Service not reachable",
            duration: 3000,
            position: 'bottom'
          });
          t.present();

        })
      }, 3000);
    });


    this.events.subscribe("gotoSearchCustomersPage", () => {
      this.nav.setRoot(HomePage);
    });


    this.events.subscribe('ModeChanged', () => {
      this.resolveMenu();
    });

    if (Constants.isWebstore) {
      Constants.customerID = this.getQueryVariable("custId");
    }

    this.events.subscribe('loginSuccess', () => {

      this.saveAttributesMap();

      this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

         localStorage.setItem("isLoggedIn","true");

      this.resolveMenu();

      if (this.cart.user.roleId == 3) {
        this.pages = this.pages.filter(page => page.showToSales == true);
      } else if (this.cart.user.roleId == 2) {
        this.pages = []; // no sidemenu if Webstore
      } else {
        this.pages = this.pages.filter(page => page.showToAdmin == true);
      }


// Localy persisted Orders In case of crash
      if (!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA") { // WEBSTORE MERGE
        this.cartManager.getPersistedOrderLocal().then((data) => {

          if (data) {

            let confirm = this.alertCtrl.create({
              title: 'Unsaved cart found.',
              message: "Customer: '" + data.customer.name + "'. What would you like to do?",
              buttons: [
                {
                  text: 'Go to old cart',
                  handler: () => {
                    this.cartManager.unPersistOrderLocal();
                    this.cartManager.setOrderTitle("");
                  }
                },
                {
                  text: 'Replace with new cart',
                  handler: () => {
                    //this.gVLogger.log(data);


                    this.cartManager.setCartFull(data);
                    this.cartManager.unPersistOrderLocal();
                    this.nav.setRoot(ItemsPage).then(() => {
                      this.nav.push(CartPage)
                    });
                    //this.gVLogger.log('Agree clicked');
                  }
                }
              ]
            });
            confirm.present();
          }
        });

        Promise.all([this.dbService.openDatabase()]).then((data) => {
          this.gVLogger.log("database is open now............!!!!!!!!!!!!" + data);
        }, (error) => {
          this.gVLogger.log(error);
        });

      }

      // Get Categories On login and save it to localstorage

      this.api.get("collection/all").map(res => res.json())
    .subscribe(data =>{

      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }

        let collection = [];
        let allClasses = data.data.classes;
        for(let col of data.data.collectionsDTO){
          col.isActive = false;
          collection.push(col);
        }

        localStorage.setItem("allClasses-"+this.cartManager.getADPCustomerUUID(),JSON.stringify(allClasses));
        localStorage.setItem("collection-"+this.cartManager.getADPCustomerUUID(),JSON.stringify(collection));

        this.events.publish('categoriesUpdated');
    });



    }); // login success ends


    this.events.subscribe('logOutSuccess', () => {
      //this.gVLogger.log("Logout Event Called");
      this.api.get("users/logout").map(res => res.json()).subscribe((res) => {
        this.storage.remove("user");
        this.storage.remove('countryCode');
        localStorage.removeItem("isLoggedIn");
      });
    });

    platform.ready().then(() => {

      if (!Constants.isWebstore) {


        ImgCache.init(() => {
            this.gVLogger.log('ImgCache init: success');
          },
          () => {
            console.error('ImgCache init: error! Check the log for errors');
          });

      }


      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      StatusBar.styleDefault();
      StatusBar.overlaysWebView(false);

    });
    if (Constants.isDebugmode) {
      imageLoaderConfig.enableDebugMode();
    }

    // set a fallback rtApiURL to use by default in case an image is not found
    imageLoaderConfig.useImageTag(true);
    imageLoaderConfig.enableSpinner(false);
    imageLoaderConfig.enableFallbackAsPlaceholder(true);
    //imageLoaderConfig.setFallbackUrl('assets/img/nan-400x400.png');
    //imageLoaderConfig.setFallbackUrl('http://cdn01.anydatapoint.com/orders-app/modus-44b44c26-cae2-4da5-bacb-226b3af7eec0/products/default2/nan-400x400.png');
    imageLoaderConfig.setMaximumCacheSize(Constants.imageCacheSize * 1024 * 1024); // in MBs
    if (Constants.isImageCacheExpiry) { // if image cache expiry enabled
      imageLoaderConfig.setMaximumCacheAge(Constants.imageCacheExpirytime * 24 * 60 * 60 * 1000); // in days
    }
    imageLoaderConfig.setCacheDirectoryName("IntelliRep-Images");


    this.backupPages = this.pages;

  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  swapCart(order) {

    this.menuController.close("testRightMenu");

    if (this.cartManager.getProductsCount() > 0 && this.cartManager.getOrderStatus() != 4) {

      //this.gVLogger.log("Products Count : " + this.cartManager.getProductsCount());

      if (this.cartManager.getOrderTitle() == "") {

        let prompt = this.alertCtrl.create({
          title: 'Please enter title for the active cart',
          inputs: [
            {
              name: 'title',
              placeholder: 'Title'
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                // this.gVLogger.log('Cancel clicked');
              }
            },
            {
              text: 'Hold',
              handler: data => {
                this.gVLogger.log(data.title);
                this.cartManager.setOrderTitle(data.title);
                this.events.publish("titleChange");
                //this.cartManager.setOrderId(this.cartManager.getOrderId());
                this.swapCall(order);

              }
            }
          ]
        });
        prompt.present();
      } else {
        this.swapCall(order);
      }
    } else {
      this.swapCall(order);
    }

  }


  swapCall(order) {
    // this.gVLogger.log("Swapping carts");
    let productsList: any = [];
    for (let orderDetail of order.orderDetailDTOs) {
      let product: any = orderDetail.productsDTO;
      productsList.push(product);
    }

    if (this.cartManager.getProductsCount() > 0 && this.cartManager.getOrderStatus() != 4) {

      var body: any = this.cartManager.genrateOrder(2, loginUserInfo.customerShippingCost); // status 2 for HOLD
      //  this.gVLogger.log(JSON.stringify(body));
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });
      this.api.post("order/place", JSON.stringify(body), options)
        .map(res => res.json())
        .subscribe(resp => {

            if(resp.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }
            if (resp.status == "200") {
              this.events.publish("titleChange");
              this.cartManager.setItems(productsList);
              this.cartManager.setOrderTitle(order.orderTitle);
              this.cartManager.setOrderId(order.id);
              this.cartManager.setOrderStatus(order.orderStatus);
              this.cartManager.setOrderMessage(order.orderMessage);

              this.nav.pop().then(() => {

                if (this.cart.user.roleId == 2) {

                } else {
                  this.nav.push(CartPage).then(() => {
                    //  this.gVLogger.log("publishing Event");
                    this.events.publish("refreshItems");
                  });
                }
              });

            } else {

              let toast = this.toastCtrl.create({
                message: resp.message,
                duration: 3000
              });
              toast.present();

            }

          }
          , error => {

          });

    } else {
      this.events.publish("titleChange");
      this.cartManager.setItems(productsList);
      this.cartManager.setOrderTitle(order.orderTitle);
      this.cartManager.setOrderStatus(order.orderStatus);
      this.cartManager.setOrderId(order.id);
      this.cartManager.setOrderMessage(order.orderMessage);

      this.nav.pop().then(() => {
        this.events.publish("refreshItems");
        if (this.cart.user.roleId == 2) {

        } else {
          this.nav.push(CartPage);
        }
      });
    }

  }

  editCartCaption(cart) {

    this.swapCart(cart);


    let prompt = this.alertCtrl.create({
      title: 'Please enter title to edit',
      inputs: [
        {
          name: 'title',
          placeholder: 'Title',
          value: cart.orderTitle
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            // this.gVLogger.log('Cancel clicked');
          }
        },
        {
          text: 'Edit',
          handler: data => {
            // this.gVLogger.log(data.title);
            this.cartManager.setOrderTitle(data.title);
            this.events.publish("titleChange");
            //this.cartManager.setOrderId(this.cartManager.getOrderId());
            this.editCartCall(cart);

          }
        }
      ]
    });
    prompt.present();
  }

  editCartCall(cart) {


    var body: any = this.cartManager.genrateOrder(2, loginUserInfo.customerShippingCost); // status 2 for HOLD
    //  this.gVLogger.log(JSON.stringify(body));
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });
    this.api.post("order/place", JSON.stringify(body), options)
      .map(res => res.json())
      .subscribe(resp => {
          if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if (resp.status == "200") {

            // this.cartManager.setItems(productsList);
            // this.cartManager.setOrderTitle(cart.orderTitle);
            // this.cartManager.setOrderId(cart.id);
            // this.cartManager.setOrderMessage(cart.orderMessage);
            this.nav.pop().then(() => {
              this.nav.push(CartPage);
            });

          } else {

            let toast = this.toastCtrl.create({
              message: resp.message,
              duration: 3000
            });
            toast.present();

          }

        }
        , error => {

        });

  }


  getQueryVariable(variable) {
    this.gVLogger.log("Query compoenent ....." + window.location.href);
    var query = window.location.href.substring(1);
    // var vars = query.split("&");
    var vars = query.split("?");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        this.gVLogger.log("varrrrPair[1] " + pair[1]);
        return pair[1];
      }
    }
    this.gVLogger.log('Query Variable ' + variable + ' not found');
  }


  resolveMenu() {

      if(Constants.IntelliStockRunningIn === "BROWSER") {
        // this.storage.get('roleId').then((data) => {
        //   this.gVLogger.log('roleId --- '+ data)
          if(ROLE.roleId === 1){
            this.pages = [
              {
                title: 'Orders',
                icon: 'ios-folder-outline',
                count: 0,
                component: MyOrderPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Bulk Shipment',
                icon: 'ios-folder-outline',
                count: 0,
                component: BulkShipmentPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: StockcartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Move Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: MoveStockCartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Consume Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: ConsumeStockCart,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Return',
                icon: 'ios-cube-outline',
                count: 0,
                component: ReceiveReturnPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Approve Return',
                icon: 'ios-cube-outline',
                count: 0,
                component: ApproveReturnPage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Manage Bad Products',
                icon: 'ios-cube-outline',
                count: 0,
                component: BadInventoryPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Place Order',
                icon: 'ios-filing-outline',
                count: 0,
                component: HomePage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Locations',
                icon: 'ios-filing-outline',
                count: 0,
                component: WarehousesPage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Work Orders',
                icon: 'ios-filing-outline',
                count: 0,
                component: WorkOrdersPage,
                showToSales: true,
                showToAdmin: true
              },


              {
                title: 'My Account',
                icon: 'ios-contact-outline',
                count: 0,
                component: MyAccountPage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Logout',
                icon: 'ios-log-out-outline',
                count: 0,
                component: LoginPage,
                showToSales: true,
                showToAdmin: true
              }
              // import menu
            ];
          }

          else if(ROLE.roleId === 3){
            // alert("in role 3 " +  this.restrictedToViewOrder)
            if(loginUserInfo.restrictedToViewOrder === 1){
              // alert("in 3")
              this.pages = [
                {
                  title: 'Orders',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: MyOrderPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Bulk Shipment',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: BulkShipmentPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Place Order',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: HomePage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Locations',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WarehousesPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Work Orders',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WorkOrdersPage,
                  showToSales: true,
                  showToAdmin: true
                },



                {
                  title: 'Logout',
                  icon: 'ios-log-out-outline',
                  count: 0,
                  component: LoginPage,
                  showToSales: true,
                  showToAdmin: true
                }
                // import menu
              ];
            }
            else {
              this.pages = [
                {
                  title: 'Orders',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: MyOrderPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Bulk Shipment',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: BulkShipmentPage,
                  showToSales: true,
                  showToAdmin: true
                },

                {
                  title: 'Place Order',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: HomePage,
                  showToSales: true,
                  showToAdmin: true
                },

                {
                  title: 'Locations',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WarehousesPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Work Orders',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WorkOrdersPage,
                  showToSales: true,
                  showToAdmin: true
                },


                {
                  title: 'Logout',
                  icon: 'ios-log-out-outline',
                  count: 0,
                  component: LoginPage,
                  showToSales: true,
                  showToAdmin: true
                }
                // import menu
              ];
            }

          }

          else {
            this.pages = [
              {
                title: 'Orders',
                icon: 'ios-folder-outline',
                count: 0,
                component: MyOrderPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Bulk Shipment',
                icon: 'ios-folder-outline',
                count: 0,
                component: BulkShipmentPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: StockcartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Move Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: MoveStockCartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Consume Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: ConsumeStockCart,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Return',
                icon: 'ios-cube-outline',
                count: 0,
                component: ReceiveReturnPage,
                showToSales: true,
                showToAdmin: true
              },
              // {
              //   title: 'Approve Return',
              //   icon: 'ios-cube-outline',
              //   count: 0,
              //   component: ApproveReturnPage,
              //   showToSales: true,
              //   showToAdmin: true
              // },

              {
                title: 'Manage Bad Products',
                icon: 'ios-cube-outline',
                count: 0,
                component: BadInventoryPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Place Order',
                icon: 'ios-filing-outline',
                count: 0,
                component: HomePage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Locations',
                icon: 'ios-filing-outline',
                count: 0,
                component: WarehousesPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Work Orders',
                icon: 'ios-filing-outline',
                count: 0,
                component: WorkOrdersPage,
                showToSales: true,
                showToAdmin: true
              },


              {
                title: 'My Account',
                icon: 'ios-contact-outline',
                count: 0,
                component: MyAccountPage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Logout',
                icon: 'ios-log-out-outline',
                count: 0,
                component: LoginPage,
                showToSales: true,
                showToAdmin: true
              }
              // import menu
            ];
          }
        // });


    }

    else if(Constants.IntelliStockRunningIn === "APP") {

        // this.storage.get('roleId').then((data) => {
        //   this.gVLogger.log('roleId --- '+ data)
          if(ROLE.roleId === 1){
            this.pages = [
              {
                title: 'Orders',
                icon: 'ios-folder-outline',
                count: 0,
                component: MyOrderPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Bulk Shipment',
                icon: 'ios-folder-outline',
                count: 0,
                component: BulkShipmentPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: StockcartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Move Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: MoveStockCartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Consume Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: ConsumeStockCart,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Return',
                icon: 'ios-cube-outline',
                count: 0,
                component: ReceiveReturnPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Approve Return',
                icon: 'ios-cube-outline',
                count: 0,
                component: ApproveReturnPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Manage Bad Products',
                icon: 'ios-cube-outline',
                count: 0,
                component: BadInventoryPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Place Order',
                icon: 'ios-cube-outline',
                count: 0,
                component: HomePage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Locations',
                icon: 'ios-filing-outline',
                count: 0,
                component: WarehousesPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Work Orders',
                icon: 'ios-filing-outline',
                count: 0,
                component: WorkOrdersPage,
                showToSales: true,
                showToAdmin: true
              },


              {
                title: 'My Account',
                icon: 'ios-contact-outline',
                count: 0,
                component: MyAccountPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'App Settings',
                icon: 'ios-settings-outline',
                count: 0,
                component: SettingsPage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Logout',
                icon: 'ios-log-out-outline',
                count: 0,
                component: LoginPage,
                showToSales: true,
                showToAdmin: true
              }
              // import menu
            ];
          }
          else if(ROLE.roleId === 3){
            if(loginUserInfo.restrictedToViewOrder === 1){
              this.pages = [
                {
                  title: 'Orders',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: MyOrderPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Bulk Shipment',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: BulkShipmentPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Place Order',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: HomePage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Locations',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WarehousesPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Work Orders',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WorkOrdersPage,
                  showToSales: true,
                  showToAdmin: true
                },

                {
                  title: 'Logout',
                  icon: 'ios-log-out-outline',
                  count: 0,
                  component: LoginPage,
                  showToSales: true,
                  showToAdmin: true
                }
                // import menu
              ];
            }else {
              this.pages = [
                {
                  title: 'Orders',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: MyOrderPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Bulk Shipment',
                  icon: 'ios-folder-outline',
                  count: 0,
                  component: BulkShipmentPage,
                  showToSales: true,
                  showToAdmin: true
                },

                {
                  title: 'Place Order',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: HomePage,
                  showToSales: true,
                  showToAdmin: true
                },

                {
                  title: 'Locations',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WarehousesPage,
                  showToSales: true,
                  showToAdmin: true
                },
                {
                  title: 'Work Orders',
                  icon: 'ios-filing-outline',
                  count: 0,
                  component: WorkOrdersPage,
                  showToSales: true,
                  showToAdmin: true
                },

                {
                  title: 'Logout',
                  icon: 'ios-log-out-outline',
                  count: 0,
                  component: LoginPage,
                  showToSales: true,
                  showToAdmin: true
                }
                // import menu
              ];
            }

          }

          else {
            this.pages = [
              {
                title: 'Orders',
                icon: 'ios-folder-outline',
                count: 0,
                component: MyOrderPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Bulk Shipment',
                icon: 'ios-folder-outline',
                count: 0,
                component: BulkShipmentPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: StockcartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Move Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: MoveStockCartPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Consume Stock',
                icon: 'ios-cube-outline',
                count: 0,
                component: ConsumeStockCart,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Receive Return',
                icon: 'ios-cube-outline',
                count: 0,
                component: ReceiveReturnPage,
                showToSales: true,
                showToAdmin: true
              },
              // {
              //   title: 'Approve Return',
              //   icon: 'ios-cube-outline',
              //   count: 0,
              //   component: ApproveReturnPage,
              //   showToSales: true,
              //   showToAdmin: true
              // },
              {
                title: 'Manage Bad Products',
                icon: 'ios-cube-outline',
                count: 0,
                component: BadInventoryPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Place Order',
                icon: 'ios-cube-outline',
                count: 0,
                component: HomePage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Locations',
                icon: 'ios-filing-outline',
                count: 0,
                component: WarehousesPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'Work Orders',
                icon: 'ios-filing-outline',
                count: 0,
                component: WorkOrdersPage,
                showToSales: true,
                showToAdmin: true
              },


              {
                title: 'My Account',
                icon: 'ios-contact-outline',
                count: 0,
                component: MyAccountPage,
                showToSales: true,
                showToAdmin: true
              },
              {
                title: 'App Settings',
                icon: 'ios-settings-outline',
                count: 0,
                component: SettingsPage,
                showToSales: true,
                showToAdmin: true
              },

              {
                title: 'Logout',
                icon: 'ios-log-out-outline',
                count: 0,
                component: LoginPage,
                showToSales: true,
                showToAdmin: true
              }
              // import menu
            ];
          }
        // });


      }
  }


  getImageLogo() {
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v=" + Math.round((new Date()).getTime() / 1000);
  }


  saveAttributesMap(){

  this.api.get("productAttributes/getAttributesAgainstAdpCustomerId")
  .map(res => res.json())
  .subscribe((results)=>{
    for(let attribute of results){
      let tempAttrib:any = {};
      tempAttrib.id = attribute.id;
      tempAttrib.attActiveStatus = attribute.attActiveStatus;
      tempAttrib.attSearchStatus = attribute.attSearchStatus;
      tempAttrib.attSequence = attribute.attSequence;
      this.cartManager.addToAttributeMap(attribute.id,attribute.attName);
      this.cartManager.addAttributePropertiesMap(attribute.id,tempAttrib)
      // this.gVLogger.log("Value => ",attribute.id,this.cartManager.getAttributeValue(attribute.id));
      for(let attributeValue of attribute.children){
        this.cartManager.addToAttributeMap(attribute.id+":"+attributeValue.id,attributeValue.attValue);
        // this.gVLogger.log("Value => ",attribute.id+":"+attributeValue.id,this.cartManager.getAttributeValue(attribute.id+":"+attributeValue.id));
      }
    }

  });


  }

  imageNotFoundServer(event){
    // alert("app component")
    // event.target.src = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
    return "assets/img/intelli-stock-V2.png";
   }




}





// WEBPACK FOOTER //
// ./src/app/app.component.ts